export const quizData=[
    {
        categoryName:"FERRARI",
        categoryID:"893bbb04-f5e6-4f52-992f-9813b2664b10",
        questions:[
            {
                questionID:"d55f99e0-d142-46c4-8263-78a5872725a4",
                statement:"Which Ferrari driver has the most world championship wins?",
                points:10,
                options:[
                    {
                        option:"Michael Schumacher",
                        isRight:true
                    },
                    {
                        option:"Sebastian Vettel",
                        isRight:false
                    },
                    {
                        option:"Niki Lauda",
                        isRight:false
                    },
                    {
                        option:"Alberto Ascari",
                        isRight:false
                    },
                ]
            },
            {
                questionID:"c8a4d64b-458f-460d-a010-96e9246a09cb",
                statement:"Which was the last Ferrari approved by Enzo?",
                points:10,
                options:[
                    {
                        option:"Ferrari Roma",
                        isRight:false
                    },
                    {
                        option:"Ferrari F40",
                        isRight:true
                    },
                    {
                        option:"Ferrari F8",
                        isRight:false
                    },
                    {
                        option:"Ferrari 812",
                        isRight:false
                    },
                ]
            },
            {
                questionID:"142095b0-9d66-4367-8c15-ba03baffbd38",
                statement:"Which model is the first ever Ferrari?",
                points:10,
                options:[
                    {
                        option:"Ferrari 812",
                        isRight:false
                    },
                    {
                        option:"Ferrari GTC4",
                        isRight:false
                    },
                    {
                        option:"Ferrari Portofino",
                        isRight:false
                    },
                    {
                        option:"Ferrari 125 S",
                        isRight:true
                    },
                ]
            },
            {
                questionID:"39291370-1559-4140-b93e-f501541daa9d",
                statement:"Which is the most expensive Ferrari that was ever sold?",
                points:10,
                options:[
                    {
                        option:"Ferrari 458 Speciale Aperta",
                        isRight:true
                    },
                    {
                        option:"Ferrari 599 GTO",
                        isRight:false
                    },
                    {
                        option:"Ferrari 599 SA Aperta",
                        isRight:false
                    },
                    {
                        option:"Ferrari GT Coupe Boano",
                        isRight:false
                    },
                ]
            },
            {
                questionID:"6e2416ad-9e8e-43ac-8833-4a25ced221ab",
                statement:"In which city of the Italy was Ferrari founded?",
                points:10,
                options:[
                    {
                        option:"Maranello",
                        isRight:true
                    },
                    {
                        option:"Milan",
                        isRight:false
                    },
                    {
                        option:"Naples",
                        isRight:false
                    },
                    {
                        option:"Florence",
                        isRight:false
                    },
                ]
            }
        ]
    },
    {
        categoryName:"NETFLIX",
        categoryID:"0e25212f-15df-46a4-856b-867ff724b7fe",
        questions:[
            {
                questionID:"0fa750df-4cdd-4af3-881d-fafd1f4dbff6",
                statement:"Which netflix series had a watch hour of 1.65 billion hours in first 28 days?",
                points:10,
                options:[
                    {
                        option:"Squid Game",
                        isRight:true
                    },
                    {
                        option:"Stranger Things",
                        isRight:false
                    },
                    {
                        option:"The Witcher",
                        isRight:false
                    },
                    {
                        option:"13 reasons why",
                        isRight:false
                    },
                ]
            },
            {
                questionID:"3b54afb9-8d04-4da9-8a3e-182f8c584b84",
                statement:"which of the two characters have appeared in all Episode of Stranger Things?",
                points:10,
                options:[
                    {
                        option:"Hopper and Joyce",
                        isRight:false
                    },
                    {
                        option:"Mike and Eleven",
                        isRight:false
                    },
                    {
                        option:"Mike and Hopper",
                        isRight:true
                    },
                    {
                        option:"Steve and Dustin",
                        isRight:false
                    },
                ]
            },
            {
                questionID:"ac630184-65e4-472e-bb0d-70cc8080ff91",
                statement:"In Witcher series, what was given to the dwarfs to take back to King Niedamir?",
                points:10,
                options:[
                    {
                        option:"Dragon Eye",
                        isRight:false
                    },
                    {
                        option:"Dragon Teeth",
                        isRight:true
                    },
                    {
                        option:"Dragon Scales",
                        isRight:false
                    },
                    {
                        option:"Dragon Egg",
                        isRight:false
                    },
                ]
            },
            {
                questionID:"423dfa72-b1ca-4d95-9fde-6399f2d4f22b",
                statement:"In squid game, how many players died in the first game",
                points:10,
                options:[
                    {
                        option:"255",
                        isRight:true
                    },
                    {
                        option:"161",
                        isRight:false
                    },
                    {
                        option:"189",
                        isRight:false
                    },
                    {
                        option:"300",
                        isRight:false
                    },
                ]
            },
            {
                questionID:"490ac0f6-7411-46ff-bb79-8b38382cb5ff",
                statement:"What is Player 001's name in squid game?",
                points:10,
                options:[
                    {
                        option:"Oh Il-nam",
                        isRight:true
                    },
                    {
                        option:"Cho Sang-woo",
                        isRight:false
                    },
                    {
                        option:"Jang Deok-Su",
                        isRight:false
                    },
                    {
                        option:"Seong Gi-hun",
                        isRight:false
                    },
                ]
            }
        ]
    }
]